'use client'

import React from 'react'

const StatsSection = () => {
  const stats = [
    {
      number: "6.5M+",
      label: "LEARNERS",
      width: 172,
      height: 127
    },
    {
      number: "4.5+",
      label: "CSAT SCORE",
      width: 145,
      height: 127
    },
    {
      number: "400+",
      label: "MENTORS FROM TOP BRANDS",
      width: 244,
      height: 127
    },
    {
      number: "4000+",
      label: "HOURS OF CONTENT",
      width: 181,
      height: 127
    },
    {
      number: "+80%",
      label: "BUSINESS OUTCOME",
      width: 319,
      height: 127,
      special: true
    }
  ]

  return (
    <div className="w-full py-8 md:py-16 bg-[#fcf8ef] md:bg-white">
      <div className="w-[90%] md:w-[80%] mx-auto">
        
        {/* Desktop - Single Row with exact dimensions */}
        <div className="hidden md:flex gap-4 justify-between">
          {stats.map((stat, index) => (
            <div
              key={index}
              className={`rounded-[20px] p-6 flex ${
                stat.special 
                  ? 'text-white justify-between items-center' 
                  : 'bg-gray-50 border border-gray-200 flex-col justify-center'
              }`}
              style={{
                width: `${stat.width}px`,
                height: `${stat.height}px`,
                backgroundColor: stat.special ? '#002726' : 'transparent'
              }}
            >
              {stat.special ? (
                <>
                  <div>
                    <div className="text-[32px] font-medium mb-1 text-green-300">
                      {stat.number}
                    </div>
                    <div className="text-[16px] font-normal text-white">
                      {stat.label}
                    </div>
                  </div>
                  <img 
                    src="https://d31bwppm8yl9g2.cloudfront.net/learner/gs/graph.png" 
                    alt="Chart" 
                    className="w-16 h-16 object-contain"
                  />
                </>
              ) : (
                <>
                  <div className="text-[32px] font-medium mb-1 text-gray-900">
                    {stat.number}
                  </div>
                  <div className="text-[14px] font-normal text-gray-600">
                    {stat.label}
                  </div>
                </>
              )}
            </div>
          ))}
        </div>

        {/* Mobile - Grid Layout */}
        <div className="md:hidden">
          <div className="grid grid-cols-2 gap-4 mb-4">
            {stats.slice(0, 4).map((stat, index) => (
              <div key={index} className="bg-white rounded-[20px] p-6 border border-gray-200 h-32 flex flex-col justify-center">
                <div className="text-[24px] md:text-[32px] font-medium mb-1 text-gray-900">
                  {stat.number}
                </div>
                <div className="text-[14px] md:text-[16px] font-normal text-gray-600">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
          
          <div 
            className="text-white rounded-[20px] p-6 h-32 flex justify-between items-center"
            style={{
              backgroundColor: '#002726'
            }}
          >
            <div>
              <div className="text-[24px] md:text-[32px] font-medium mb-1 text-green-300 relative z-10">
                {stats[4].number}
              </div>
              <div className="text-[14px] font-normal text-white relative z-10">
                {stats[4].label}
              </div>
            </div>
            <img 
              src="https://d31bwppm8yl9g2.cloudfront.net/learner/gs/graph.png" 
              alt="Chart" 
              className="w-12 h-12 md:w-16 md:h-16 object-contain"
            />
          </div>
        </div>
        
      </div>
    </div>
  )
}

export default StatsSection